import { isNil } from 'lodash-es'
import React, { FunctionComponent, useCallback, useMemo } from 'react'

import { usePrevious } from '../../../../util/usePrevious'
import {
  VehicleCardConfigVRN,
  VehicleCardVRN,
  VehicleTabsConfigVRN,
  VehicleTabsVRN,
} from '../../../organisms/vehicle'
import { FormInputProps } from '../../types'
import { VehicleInputValueVRN } from './types'

export const VehicleTabsFormInputVRN: FunctionComponent<
  FormInputProps<VehicleInputValueVRN, VehicleTabsConfigVRN & VehicleCardConfigVRN>
> = ({ t, tKey, tName, value, onChange, meta }) => {
  const previous = usePrevious(value)

  const onReset = useCallback(() => onChange(null), [onChange])

  const onChangeVRN = useCallback(
    (vrn: string | undefined) =>
      onChange({
        ...value,
        vrn,
      }),
    [onChange, value],
  )

  const currentOrPrevious = value ?? previous

  const initialTab = useMemo(
    () => (isNil(currentOrPrevious?.regLookup) || currentOrPrevious.regLookup ? 0 : 1),
    [currentOrPrevious],
  )

  return value?.specification ? (
    <VehicleCardVRN
      specification={value.specification}
      vrn={value.vrn}
      onChange={onReset}
      onChangeVRN={onChangeVRN}
      config={meta}
    />
  ) : (
    <VehicleTabsVRN
      t={t}
      tKey={tKey}
      tName={tName}
      config={meta}
      initialTab={initialTab}
      value={currentOrPrevious}
      onChange={onChange}
    />
  )
}
